<template>
  <div>
    <div v-for="(project, index) in projects" class="row m-b-30" :key="project.id">
      <div class="col-auto p-r-0">
        <img src="https://gazovik-neft.ru/assets/images/rvs_news.png" class="img-radius img-40 align-top m-r-15" />
      </div>
      <div class="col">
        <h6 class="m-b-5">
          {{ project.name }}
          <span class="text-muted f-right f-13"
            ><b-btn :to="'/risk/' + project.id">Перейти</b-btn
            ><b-btn
              v-b-modal.project_remove_modal
              class="m-2"
              variant="danger"
              @click="
                $refs.project_remove_modal.proj_id = project.id;
                $refs.project_remove_modal.p_index = index;
              "
              >Удалить</b-btn
            ></span
          >
        </h6>
        <p class="text-muted m-b-0">
          <b-badge v-if="project.status == 0">Не рассчитан</b-badge>
          <b-badge v-if="project.status == 1" variant="primary">В процессе расчета</b-badge>
          <b-badge v-if="project.status == 3" variant="danger">Возникли ошибки</b-badge>
          <b-badge v-if="project.status == 2" variant="success">Успешно рассчитан</b-badge>
        </p>
      </div>
    </div>
    <b-modal ref="project_remove_modal" hide-footer id="project_remove_modal" title="Удалить">
      <div class="d-block text-center">
        <h3>Вы действительно хотите удалить этот проект?</h3>
      </div>
      <b-btn
        class="mt-3 btn-outline"
        variant="danger"
        block
        @click="
          remove($refs.project_remove_modal.proj_id, $refs.project_remove_modal.p_index);
          $refs.project_remove_modal.hide();
        "
        >Удалить
      </b-btn>
    </b-modal>
  </div>
</template>

<script>
export default {
  name: "Risk",
  props: {
    projects: Array,
  },
  methods: {
    remove: function (proj_id, index) {
      this.$http
        .get("category/projects/remove", {
          params: {
            proj_id: proj_id,
          },
        })
        .then(() => {
          // JSON responses are automatically parsed.
          this.projects.splice(index, 1);
        })
        .catch((e) => {
          alert(this.$t("error"), e);
        });
    },
  },
};
</script>
